import { Alert, Button, IconButton, Portal, Snackbar } from '@mui/material';
// Adds a navigation breadcrumb (not an error capture), which the reporting helpers don't cover.
// oxlint-disable-next-line no-restricted-imports
import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { XIcon } from 'lucide-react';
import { useCallback, useState } from 'react';
import { settingsQueryOptions } from '@/api/services/settings';

export const VersionAlert = () => {
  const { data: tag } = useQuery({ ...settingsQueryOptions, select: ({ tag }) => tag });

  if (!tag) {
    return null;
  }
  return <VersionAlertContent imageTag={tag} />;
};

function VersionAlertContent({ imageTag }: { imageTag: string }) {
  const [initialImageTag, setInitialImageTag] = useState(() => imageTag);
  const onClose = useCallback(() => setInitialImageTag(imageTag), [imageTag]);

  if (imageTag === initialImageTag) {
    return null;
  }
  return (
    <Portal>
      <Snackbar open={true}>
        <Alert
          severity="info"
          action={
            <>
              <Button
                size="small"
                onClick={() => {
                  Sentry.addBreadcrumb({
                    category: 'reload',
                    message: 'VersionAlert: REFRESH button clicked to reload the page',
                    level: 'info',
                  });
                  window.location.reload();
                }}
              >
                REFRESH
              </Button>
              <IconButton onClick={onClose}>
                <XIcon size={20} />
              </IconButton>
            </>
          }
          sx={{
            '&>.MuiAlert-action': {
              padding: 0,
              marginLeft: 1,
            },
          }}
        >
          A new version of Qdrant Cloud is available
        </Alert>
      </Snackbar>
    </Portal>
  );
}
